"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _theme = require("../../theme");

var _styles = _interopRequireWildcard(require("./../styles"));

var _Image = require("../Image");

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n          opacity: ", ";\n          max-width: 100%;\n          max-height: 100%;\n          display: block;\n          transition: transform 0.3s, opacity 0.3s cubic-bezier(0.1, 0.25, 0.75, 0.9);\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n          opacity: ", ";\n          display: block;\n          width: auto;\n          height: auto;\n          position: absolute;\n          transition: opacity 0.3s cubic-bezier(0.1, 0.25, 0.75, 0.9);\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n          max-width: 100%;\n          max-height: 100%;\n          opacity: ", ";\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n          opacity: ", ";\n          ", "\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Img = (0, _theme.styled)('img', {
  shouldForwardProp: _Image.ommitImgProps
})(_templateObject(), function (_ref) {
  var imageFit = _ref.imageFit,
      isImageLoaded = _ref.isImageLoaded;

  switch (imageFit) {
    case 'center':
      {
        return (0, _theme.css)(_templateObject2(), isImageLoaded ? 1 : 0, _styles.baseImageCss);
      }

    case 'cover':
    case 'contain':
      {
        return (0, _theme.css)(_templateObject3(), isImageLoaded ? 1 : 0);
      }

    case 'none':
      {
        return (0, _theme.css)(_templateObject4(), isImageLoaded ? 1 : 0);
      }

    default:
      {
        return (0, _theme.css)(_templateObject5(), isImageLoaded ? 1 : 0);
      }
  }
}, _styles.default.getImgStyle);
var _default = Img;
exports.default = _default;